import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarAccidentFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.9899 4.19902L12.7048 0.93457L12.4863 6.13226L14.0449 6.19777L14.1148 4.53497L15.7003 6.11054L17.6814 5.07519L17.1097 7.23612L18.9968 8.43407L17.3906 8.86989L17.7992 10.3755L22.8199 9.01314L18.9099 6.5311L20.0944 2.05387L15.9899 4.19902ZM17.3998 11.9996C18.3077 11.9996 19.1728 11.8162 19.9601 11.4846V17.1C19.9601 18.2 19.0801 19.1 17.9801 19.1C17.1201 19.1 16.2401 18.58 16.0201 17.5H7.98008C7.76008 18.58 6.88008 19.1 6.02008 19.1C4.92008 19.1 4.04008 18.2 4.04008 17.1V11.2599L4.52008 10.28H3.08008V8.67995H5.28008L6.96008 5.19995H10.8028C10.8008 5.26624 10.7998 5.33279 10.7998 5.39956C10.7998 9.04464 13.7547 11.9996 17.3998 11.9996ZM12.0001 13.5199C11.2401 13.5199 10.5801 13.1399 10.1601 12.5599H7.08008V14.0599H9.58008C10.2401 14.6199 11.0801 14.9799 12.0001 14.9799C12.9201 14.9799 13.7601 14.6199 14.4201 14.0599H16.9201V12.5599H13.8401C13.4201 13.1399 12.7601 13.5199 12.0001 13.5199Z"
      />
    </SvgIcon>
  );
});
